module.exports = __webpack_public_path__ + "static/LouiseHarrison-e6496b8af86b2ffb400eb1673e944f6b.jpg";